import { adminMarketingQueryKeys as e } from "./adminMarketingQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { adminMarketingApi as r } from "@maat/api-main";
//#region src/marketing/admin/useDeleteMarketingAssetMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.remove(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.list() });
		}
	});
};
//#endregion
export { i as useDeleteMarketingAssetMutation };
